export const transferTypes = {
    clean: "[Clean] Cleaning transfer options",
    init: "[Init] Initializing transfer options",
    setProduct: "[pushProduct] Append product to transfers",
    updateIds: "[pushProduct] Append product to transfers",
};
